import { defineMessages } from 'react-intl'

export default defineMessages({
  secretaryView: {
    id: 'secretaryDashboard.secretaryView',
    defaultMessage: 'Secretary View'
  },
  logout: {
    id: 'secretaryDashboard.logout',
    defaultMessage: 'Logout'
  },
  unableToLoadSession: {
    id: 'secretaryDashboard.unableToLoadSession',
    defaultMessage: 'Unable to load secretary session. Please log in again.'
  },
  addPatientToQueue: {
    id: 'secretaryDashboard.addPatientToQueue',
    defaultMessage: 'Add Patient to Queue'
  },
  existingPatient: {
    id: 'secretaryDashboard.existingPatient',
    defaultMessage: 'Existing Patient'
  },
  newPatient: {
    id: 'secretaryDashboard.newPatient',
    defaultMessage: 'New Patient'
  },
  searchPatientPlaceholder: {
    id: 'secretaryDashboard.searchPatientPlaceholder',
    defaultMessage: 'Search patient name...'
  },
  typeAtLeast2Chars: {
    id: 'secretaryDashboard.typeAtLeast2Chars',
    defaultMessage: 'Type at least 2 characters'
  },
  noPatientsFound: {
    id: 'secretaryDashboard.noPatientsFound',
    defaultMessage: 'No patients found'
  },
  patientAddedToQueue: {
    id: 'secretaryDashboard.patientAddedToQueue',
    defaultMessage: 'Patient added to queue'
  },
  failedToAddToQueue: {
    id: 'secretaryDashboard.failedToAddToQueue',
    defaultMessage: 'Failed to add patient to queue'
  },
  name: {
    id: 'secretaryDashboard.name',
    defaultMessage: 'Name'
  },
  phone: {
    id: 'secretaryDashboard.phone',
    defaultMessage: 'Phone'
  },
  dateOfBirth: {
    id: 'secretaryDashboard.dateOfBirth',
    defaultMessage: 'Date of Birth'
  },
  sex: {
    id: 'secretaryDashboard.sex',
    defaultMessage: 'Sex'
  },
  male: {
    id: 'secretaryDashboard.male',
    defaultMessage: 'Male'
  },
  female: {
    id: 'secretaryDashboard.female',
    defaultMessage: 'Female'
  },
  addPatient: {
    id: 'secretaryDashboard.addPatient',
    defaultMessage: 'Add Patient'
  },
  failedToCreatePatient: {
    id: 'secretaryDashboard.failedToCreatePatient',
    defaultMessage: 'Failed to create patient'
  },
  todaysQueue: {
    id: 'secretaryDashboard.todaysQueue',
    defaultMessage: "Today's Queue"
  },
  noPatientsInQueue: {
    id: 'secretaryDashboard.noPatientsInQueue',
    defaultMessage: 'No patients in queue yet'
  },
  waiting: {
    id: 'secretaryDashboard.waiting',
    defaultMessage: 'Waiting'
  },
  done: {
    id: 'secretaryDashboard.done',
    defaultMessage: 'Done'
  },
  markDone: {
    id: 'secretaryDashboard.markDone',
    defaultMessage: 'Mark done'
  },
  failedToMarkDone: {
    id: 'secretaryDashboard.failedToMarkDone',
    defaultMessage: 'Failed to mark patient as done'
  },
  scheduledAppointment: {
    id: 'secretaryDashboard.scheduledAppointment',
    defaultMessage: 'Appointment'
  },
  walkIn: {
    id: 'secretaryDashboard.walkIn',
    defaultMessage: 'Walk-in'
  },
  failedToReorder: {
    id: 'secretaryDashboard.failedToReorder',
    defaultMessage: 'Failed to reorder'
  },
  patientRemovedFromQueue: {
    id: 'secretaryDashboard.patientRemovedFromQueue',
    defaultMessage: '{name} removed from queue'
  },
  failedToRemovePatient: {
    id: 'secretaryDashboard.failedToRemovePatient',
    defaultMessage: 'Failed to remove patient'
  },
  moveUp: {
    id: 'secretaryDashboard.moveUp',
    defaultMessage: 'Move up'
  },
  moveDown: {
    id: 'secretaryDashboard.moveDown',
    defaultMessage: 'Move down'
  },
  removeFromQueue: {
    id: 'secretaryDashboard.removeFromQueue',
    defaultMessage: 'Remove from queue'
  },
  creatingPatient: {
    id: 'secretaryDashboard.creatingPatient',
    defaultMessage: 'Creating...'
  },
  nameRequired: {
    id: 'secretaryDashboard.nameRequired',
    defaultMessage: 'Patient name is required'
  },
  dateOfBirthRequired: {
    id: 'secretaryDashboard.dateOfBirthRequired',
    defaultMessage: 'Date of birth is required'
  },
  sexRequired: {
    id: 'secretaryDashboard.sexRequired',
    defaultMessage: 'Sex is required'
  },
  fullNamePlaceholder: {
    id: 'secretaryDashboard.fullNamePlaceholder',
    defaultMessage: 'Full name'
  },
  selectSexPlaceholder: {
    id: 'secretaryDashboard.selectSexPlaceholder',
    defaultMessage: 'Select sex'
  }
})
